import {
    CART_ROOT_ELEMENT_ID,
    LK_ROOT_ELEMENT_ID,
    USER_HEADER_PROFILE_ROOT_ELEMENT_ID,
} from 'lib/constants';

// Проверяет, является текущая сессия дилерской.
// Это не совсем честная проверка, так как мы завязываемся на аттбиуты DOM элементов,
// которые должны быть установлены на стороне бэка, если сессия дилерская.
// Но это самый простой способ
export function isDealersLk() {
    const rootElement = document.getElementById(LK_ROOT_ELEMENT_ID);
    const dataDealersLk = rootElement?.getAttribute('data-dealers-lk');

    const cartRootElement = document.getElementById(CART_ROOT_ELEMENT_ID);
    const dataCartDealer = cartRootElement?.getAttribute('data-dealer');

    const userHeaderProfileRootElement = document.getElementById(
        USER_HEADER_PROFILE_ROOT_ELEMENT_ID,
    );
    const dataProfileHeaderDealer =
        userHeaderProfileRootElement?.getAttribute('data-dealer');

    return Boolean(dataDealersLk || dataCartDealer || dataProfileHeaderDealer);
}
